// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2euEG","search":"Settings_search__29aWM","filter":"Settings_filter__32mmS"};